import { render, staticRenderFns } from "./exhibit.vue?vue&type=template&id=7c787a8d&scoped=true"
import script from "./exhibit.vue?vue&type=script&lang=js"
export * from "./exhibit.vue?vue&type=script&lang=js"
import style0 from "./exhibit.vue?vue&type=style&index=0&id=7c787a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c787a8d",
  null
  
)

export default component.exports